import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import EnhancedHome from './pages/EnhancedHome';
import Payment from './pages/Payment';
import Results from './pages/Results';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import UserLogin from './pages/UserLogin';
import MyPredictions from './pages/MyPredictions';
import ReferralDashboard from './pages/ReferralDashboard';
import ResetPassword from './pages/ResetPassword';
import AboutUs from './pages/AboutUs';
import CounselingRequest from './pages/CounselingRequest';
import ExpertCounseling from './pages/ExpertCounseling';
import DynamicPage from './pages/DynamicPage';
import TestSeries from './pages/TestSeries';
import FormGuide from './pages/FormGuide';
import StudentDashboard from './pages/StudentDashboard';
import DiscussionForum from './pages/DiscussionForum';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EnhancedHome />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/guide" element={<FormGuide />} />
          <Route path="/help" element={<FormGuide />} />
          <Route path="/login" element={<UserLogin />} />
          <Route path="/user-login" element={<UserLogin />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/my-predictions" element={<MyPredictions />} />
          <Route path="/referral" element={<ReferralDashboard />} />
          <Route path="/dashboard" element={<StudentDashboard />} />
          <Route path="/student-dashboard" element={<StudentDashboard />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/results" element={<Results />} />
          <Route path="/test-series" element={<TestSeries />} />
          <Route path="/forum" element={<DiscussionForum />} />
          <Route path="/forum/:topicId" element={<DiscussionForum />} />
          <Route path="/counseling-request" element={<CounselingRequest />} />
          <Route path="/expert-counseling" element={<ExpertCounseling />} />
          <Route path="/counseling" element={<ExpertCounseling />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          {/* Dynamic CMS Pages - must be last */}
          <Route path="/:slug" element={<DynamicPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;